import React, { useEffect, useState } from "react";
import { useMessage } from "../MessageProvider/MessageProvider";
import moment from "moment";
import "./Lists.css";
import { Checkbox, Tooltip } from "antd";
import { FaRegComment } from "react-icons/fa";

import formatNumberWithSpaces from "../../Components/NumberToWords/FormatNumber";
import { useNavigate } from "react-router-dom";

const TicketItem = React.memo(function ({
  el,
  data,
  setData,
  selected,
  setSelected,
  isDragging,
}) {
  let [editModalOpen, setEditModalOpen] = useState(false);
  const messageApi = useMessage();
  let navigate = useNavigate();

  const copyContent = async (text) => {
    try {
      await navigator.clipboard.writeText(text);

      messageApi.open({
        type: "success",
        content: "Copied!",
      });
    } catch (err) {
      messageApi.open({
        type: "success",
        content: "Failed to copy!",
      });
    }
  };

  const toggleSelection = (id) => {
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  return (
    <div className="relative">
      {/* 1 ta katta germetika
      <ViewAmmafos
        getData={() => {}}
        isModalOpen={editModalOpen}
        setIsModalOpen={setEditModalOpen}
        id={el?.id}
      /> */}
      {selected?.size > 0 ? (
        <Checkbox
          className="absolute top-[40%]"
          checked={selected.has(el?.id)}
          onChange={() => toggleSelection(el?.id)}
        ></Checkbox>
      ) : null}
      <div
        onContextMenu={(e) => {
          e.preventDefault();
          toggleSelection(el?.id);
        }}
        // to={"/customer/" + el.id} #10b981 el?.
        style={{
          fontSize: "10px",
          backgroundColor: el?.bgColor,
        }}
        className={
          selected.has(el.id)
            ? `transition-border duration-101  text-stone-900 w-auto text-bold cursor-pointer shadow-lg  border-[2px] border-indigo-500 hover:text-sky-400  ml-[20px]  m-auto  inner_table text-[12px] box-border  ${
                isDragging ? "cursor-grabbing" : ""
              } bg-[${el?.bgColor}]`
            : el.customer_id
            ? `text-stone-900 w-auto text-bold cursor-pointer shadow-sm  border-[1px] border-[#bfbfbf] bg-[#10b981] hover:text-[#FFF]  ml-[20px]  m-auto  inner_table text-[12px] box-border ${
                isDragging ? "cursor-grabbing" : ""
              } bg-[${el?.bgColor}]`
            : `text-stone-900 w-auto text-bold cursor-pointer shadow-sm  border-[1px] border-[#bfbfbf] hover:text-sky-400  m-auto  ml-[20px]  inner_table text-[12px] box-border ${
                isDragging ? "cursor-grabbing" : ""
              } bg-[${el?.bgColor}]`
        }
        onDoubleClick={() => {
          setEditModalOpen(true);
        }}
      >
        <p
          className="text-[12px] select-none p-0 m-0 flex-1 text-center border-r-[1px]  border-[#000] w-[100%] h-[100%] flex items-center justify-center"
          onClick={() => {
            copyContent(el?.organization);
          }}
        >
          {el?.index}
        </p>
        <p
          className="text-[12px] select-none p-0 m-0 flex-1 text-center"
          onClick={() => {
            copyContent(el?.organization);
          }}
        >
          {el?.organization}
        </p>
        {el?.customer_id ? (
          <Tooltip
            placement="left"
            title={`${el?.customer_name} \n ID: ${el?.customer_id}`}
          >
            <p
              className="text-[12px] select-none p-0 m-0 flex-1 text-center"
              onClick={() => {
                copyContent(el?.ticket?.ticket);
              }}
              onDoubleClick={() => {
                navigate("/customers/" + el?.customer_id);
              }}
            >
              {el?.ticket?.ticket}
            </p>
          </Tooltip>
        ) : (
          <p
            className="text-[12px] select-none p-0 m-0 flex-1 text-center"
            onClick={() => {
              copyContent(el?.ticket?.ticket);
            }}
          >
            {el?.ticket?.ticket}
          </p>
        )}
        <p
          className="text-[12px] select-none p-0 m-0 flex-1 text-center"
          onClick={() => {
            copyContent(moment(el?.ticket?.date).format("DD.MM.YYYY"));
          }}
        >
          {moment(el?.ticket?.date).format("DD.MM.YYYY")}
        </p>
        <h2
          className="text-[12px] select-none p-0 m-0 flex-1 text-center"
          onClick={() => {
            copyContent(el?.name);
          }}
        >
          {el?.name}
        </h2>
        <p
          className="text-[12px] select-none p-0 m-0 flex-1 text-center"
          onClick={() => {
            copyContent(el?.INN);
          }}
        >
          {el?.INN}
        </p>
        <p
          className="text-[12px] select-none p-0 m-0 flex-1 text-center"
          onClick={() => {
            copyContent(el?.believer?.id);
          }}
        >
          {el?.believer?.id}
        </p>
        <p
          className="text-[12px] select-none p-0 m-0 flex-0 text-center"
          onClick={() => {
            copyContent(el?.believer?.name);
          }}
        >
          {el?.believer?.name}
        </p>

        <p
          className="text-[12px] select-none p-0 m-0 flex-1 text-center"
          onClick={() => {
            copyContent(el?.ykx?.date);
          }}
        >
          {moment(el?.ykx?.date).format("DD.MM.YYYY")}
        </p>
        <p
          className="text-[12px] select-none p-0 m-0 flex-1 text-center"
          onClick={() => {
            copyContent(el?.ykx?.date);
          }}
        >
          {el?.ykx?.ykx}
        </p>
        <p
          className="text-[12px] select-none p-0 m-0 flex-1 text-center"
          onClick={() => {
            copyContent(el?.product);
          }}
        >
          {el?.product}
        </p>
        <p
          className="text-[12px] select-none p-0 m-0 flex-1 text-center"
          onClick={() => {
            copyContent("Tn");
          }}
        >
          Tn
        </p>
        <p
          className="text-[12px] select-none p-0 m-0 flex-1 text-center"
          onClick={() => {
            copyContent(el?.tonna);
          }}
        >
          {el?.tonna}
        </p>

        <p className="text-[12px] select-none p-0 m-0 flex-1 text-center">
          {formatNumberWithSpaces(el?.price)}
        </p>
        <p className="text-[12px] select-none p-0 m-0 flex-1 text-center">
          {formatNumberWithSpaces((el?.price / el?.tonna).toFixed(2))}
        </p>

        <Tooltip
          placement="left"
          title={`${el?.comment ? el?.comment : ""} \n\n `}
        >
          <p className=" text-[12px] select-none p-0 m-0 flex justify-center items-center">
            <FaRegComment />
          </p>
        </Tooltip>
      </div>
    </div>
  );
});

export default TicketItem;
